import { request } from "../../apis";

export const apiGetCurrency = (params) =>
  request("get", `/country`, params, true);
